import {mapGetters, mapActions} from "vuex";
import * as moment from "moment/moment";

export default {
    components: {
        Header: () => import('@/components/header/index.vue'),
        leftBar: () => import('@/components/left-bar/index.vue'),
    },
    data() {
        return {
            typeTableShow: false,

            // FILTERS

            productCategories: null,
            productCategoriesId: null,

            products: null,
            productsId: null,

            orderings: null,
            orderingsId: null,

            cancelReason: [
                {
                    id:'0',
                    title: this.$t('popupOrder.cancel_reason_0')
                },
                {
                    id:'1',
                    title: this.$t('popupOrder.cancel_reason_1')
                },
                {
                    id:'2',
                    title: this.$t('popupOrder.cancel_reason_2')
                },
                {
                    id:'3',
                    title: this.$t('popupOrder.cancel_reason_3')
                },
                {
                    id:'4',
                    title: this.$t('popupOrder.cancel_reason_4')
                },
            ],
            cancelReasonId: 0,
            cancelReasonIdToggle: false,

            orderStatuses: null,
            orderStatusesId: [],
            orderStatusesToggle: false,

            shipmentMethods: null,
            shipmentMethodsId: null,
            shipmentMethodsToggle: false,

            employees: null,
            employeesAll: [],
            employeesId: null,
            employeesToggle: false,

            departments: null,
            departmentsId: null,
            departmentsToggle: false,

            paymentMethods: null,
            paymentMethodsId: null,
            paymentMethodsToggle: false,

            utmSource: null,
            utmSourceId: null,
            utmSourceToggle: false,

            utmMedium: null,
            utmMediumId: null,
            utmMediumToggle: false,

            utmTerms: null,
            utmTermsId: null,
            utmTermsToggle: false,

            utmContents: null,
            utmContentsId: null,
            utmContentsToggle: false,

            utmCampaigns: null,
            utmCampaignsId: null,
            utmCampaignsToggle: false,

            date: {
                to: 0,
                from: 0
            },

            // Розміри сторінки узгоджені з ReportRequest::rules().
            perPageOptions: [10, 25, 50, 100, 150, 200, 300, 500],

            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs: [
                {
                    key: 'id',
                    label: 'id',
                },
                {
                    key: 'order_id',
                    label: 'order_id',
                },
                {
                    key: 'created_at',
                    labelKey: 'statsOrders.created',
                },
                {
                    key: 'updated_at',
                    labelKey: 'statsOrders.updated',
                },
                {
                    key: 'order_products',
                    labelKey: 'statsOrders.products',
                },
                {
                    key: 'upsale_products',
                    labelKey: 'statsOrders.upsale_products',
                },
                {
                    key: 'price',
                    labelKey: 'statsOrders.price',
                },
                {
                    key: 'price_air',
                    labelKey: 'statsOrders.air',
                },
                {
                    key: 'price_all',
                    labelKey: 'statsOrders.total',
                },
                {
                    key: 'order_margin',
                    labelKey: 'statsOrders.margin'
                },
                {
                    key: 'shipment_method_id',
                    labelKey: 'statsOrders.delivery',
                },
                {
                    key: 'shipment_date',
                    labelKey: 'statsOrders.sent',
                },
                {
                    key: 'order_status_id',
                    labelKey: 'statsOrders.status',
                },
                {
                    key: 'payment_method_id',
                    labelKey: 'statsOrders.payment',
                },
                {
                    key: 'employee_id',
                    labelKey: 'statsOrders.employee',
                },
                {
                    key: 'department_id',
                    labelKey: 'statsOrders.department',
                },
                {
                    key: 'site',
                    labelKey: 'statsOrders.source',
                },
                {
                    key: 'utm_source',
                    label: 'utm_source',
                },
                {
                    key: 'utm_medium',
                    label: 'utm_medium',
                },
                {
                    key: 'utm_term',
                    label: 'utm_terms',
                },
                {
                    key: 'utm_content',
                    label: 'utm_contents',
                },
                {
                    key: 'utm_campaign',
                    label: 'utm_campaigns',
                },
            ],
            productFieldDefs: [
                {
                    key: 'product_id',
                    label: 'id'
                },
                {
                    key: 'title',
                    labelKey: 'statsOrders.product_title'
                },
                {
                    key: 'quantity',
                    labelKey: 'statsOrders.product_quantity'
                },
                {
                    key: 'price',
                    labelKey: 'statsOrders.product_sum'
                },
            ],

            baseChartOptions: {
                chart: {
                    id: 'chart2',
                    type: 'line',
                    stacked: true,
                    // Висоту задає проп height у index.vue; тут її бути не повинно —
                    // updateOptions() глибоко мержить options і затре значення пропа.
                    toolbar: {
                        show: false
                    }
                },
                stroke: {
                    width: [2, 1, 1, 1]
                },
                dataLabels: {
                    enabled: false
                },
                fill: {
                    opacity: 1,
                },
                markers: {
                    size: 0
                },
                legend: {
                    position: 'right',
                    horizontalAlign: 'center',
                    offsetY: 70,
                    offsetX: -10,
                },
                xaxis: {
                    categories: ['02:00', '04:00', '08:00', '12:00', '14:00', '16:00', '18:00', '20:00', '23:59'],
                },
                noData: {
                    text: 'Loading...'
                }
            },
            baseChartOptionsLine: {
                chart: {
                    id: 'chart1',
                    // Висоту задає проп height у index.vue (див. baseChartOptions).
                    type: 'area',
                    brush: {
                        target: 'chart2',
                        enabled: true
                    },
                    selection: {
                        enabled: true,
                        xaxis: {
                            min: 1,
                            max: 15,
                        }
                    },
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        opacityFrom: 0.91,
                        opacityTo: 0.8,
                    }
                },
                xaxis: {
                    categories: ['02:00', '04:00', '08:00', '12:00', '14:00', '16:00', '18:00', '20:00', '23:59'],
                    tooltip: {
                        enabled: false
                    }
                },
                yaxis: {
                    tickAmount: 1
                },
                legend: {
                    show: false
                },
                noData: {
                    text: 'Loading...'
                }
            },
        }
    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        productFields() {
            return this.productFieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide: 'config/menuHide',
            prepareFilters: 'statistics/prepareFilters',
            reportOrders: 'statistics/orders',
            reportProducts: 'statistics/products',
            pagination: 'statistics/pagination',
            productsPagination: 'statistics/productsPagination',
            totals: 'statistics/totals',
            charts: 'statistics/charts',
            perPage: 'statistics/perPage',
            ordersPage: 'statistics/page',
            productsPage: 'statistics/productsPage',
            reportLoading: 'statistics/loading',
            reportError: 'statistics/error',
            orderStatusList: 'orders/orderStatusList',
        }),
        /**
         * Рядки таблиці замовлень: серверний DTO + підписи довідників.
         * Жодних підсумків тут не рахується.
         */
        tableItems() {
            return this.reportOrders.map(item => {
                return {
                    ...item,
                    created_at: item.created_at ? moment(item.created_at).format('YYYY-MM-DD HH-mm-ss') : null,
                    updated_at: item.updated_at ? moment(item.updated_at).format('YYYY-MM-DD HH-mm-ss') : null,
                    shipment_date: item.shipment_date ? moment(item.shipment_date).format('YYYY-MM-DD HH-mm-ss') : null,
                    shipment_method_id: this.findTitle(this.shipmentMethods, item.shipment_method_id),
                    order_status_id: this.findTitle(this.orderStatuses, item.order_status_id),
                    payment_method_id: this.findTitle(this.paymentMethods, item.payment_method_id),
                    employee_id: this.findTitle(this.employeesAll, item.employee_id),
                    department_id: this.findTitle(this.departments, item.department_id),
                }
            });
        },
        productItems() {
            return this.reportProducts;
        },
        ordersInfo() {
            return {
                withoutUpsale: this.totals ? this.totals.orders_without_upsell : 0,
                withUpsale: this.totals ? this.totals.orders_with_upsell : 0,
                percentUpsale: this.totals ? this.totals.orders_upsell_percent : '0.00',
            };
        },
        productsInfo() {
            return {
                allLength: this.totals ? this.totals.products_quantity : 0,
                mainLength: this.totals ? this.totals.products_main_quantity : 0,
                dopLength: this.totals ? this.totals.products_upsell_quantity : 0,
                percentUpsale: this.totals ? this.totals.products_upsell_percent : '0.00',
            };
        },
        productsInfoPrice() {
            return {
                allPrice: this.totals ? this.totals.revenue.all : '0.00',
                mainPrice: this.totals ? this.totals.revenue.main : '0.00',
                dopPrice: this.totals ? this.totals.revenue.upsell : '0.00',
            };
        },
        marginInfo() {
            return {
                margin: this.totals ? this.totals.margin.all : '0.00',
                mainPrice: this.totals ? this.totals.margin.main : '0.00',
                dopPrice: this.totals ? this.totals.margin.upsell : '0.00',
            };
        },
        marginAverage() {
            return this.totals ? this.totals.margin.average : '0.00';
        },
        revenueAverage() {
            return this.totals
                ? this.mediumPrice(this.totals.revenue.all, this.totals.orders_count)
                : '0.00';
        },
        air() {
            return {
                allCount: this.totals ? this.totals.air.all : '0.00',
                allCountPercent: this.totals ? this.totals.air.percent_of_revenue : '0.00',
            };
        },
        motivation() {
            return this.totals ? this.totals.motivation : '0.00';
        },
        logistics() {
            return this.totals ? this.totals.logistics : '0.00';
        },
        chartCategories() {
            return this.charts ? this.charts.categories : [];
        },
        series() {
            if (!this.charts) {
                return [];
            }
            const statuses = (this.orderStatusList && this.orderStatusList.data) || [];
            const result = this.charts.statuses.map(status => {
                const statusInfo = statuses.find(item => Number(item.id) === Number(status.id));
                return {
                    name: statusInfo ? statusInfo.title : String(status.id),
                    type: 'column',
                    id: status.id,
                    color: statusInfo ? statusInfo.color : '#999999',
                    data: status.data,
                };
            });
            result.push({
                name: this.$t('statsOrders.all'),
                type: 'line',
                color: '#000',
                data: this.charts.all,
            });

            return result;
        },
        chartOptions() {
            return {
                ...this.baseChartOptions,
                xaxis: {
                    ...this.baseChartOptions.xaxis,
                    categories: this.chartCategories,
                },
                chart: {
                    ...this.baseChartOptions.chart,
                    selection: {
                        enabled: true,
                        xaxis: {
                            min: 1,
                            max: Math.max(this.chartCategories.length, 1),
                        },
                    },
                },
            };
        },
        chartOptionsLine() {
            return {
                ...this.baseChartOptionsLine,
                xaxis: {
                    ...this.baseChartOptionsLine.xaxis,
                    categories: this.chartCategories,
                },
                chart: {
                    ...this.baseChartOptionsLine.chart,
                    selection: {
                        ...this.baseChartOptionsLine.chart.selection,
                        xaxis: {
                            min: 1,
                            max: Math.max(this.chartCategories.length, 1),
                        },
                    },
                },
            };
        },
    },
    watch: {
        prepareFilters(e) {
            if (e) {

                this.date = {
                    from: moment(e.min_created_from).format('YYYY-MM-DD'),
                    to: moment(e.max_created_from).format('YYYY-MM-DD'),
                };
                let key;
                this.productCategories = [];
                for (key in e.product_categories) {
                    this.productCategories.push({
                        id: key,
                        title: e.product_categories[key]
                    })
                }
                this.productCategories.reverse();
                this.productCategoriesId = this.productCategories[0].id;

                this.products = [];
                for (key in e.products) {
                    this.products.push({
                        id: key,
                        title: e.products[key]
                    })
                }
                this.products.reverse();
                this.productsId = this.products[0].id;

                this.orderings = [];
                for (key in e.orderings) {
                    this.orderings.push({
                        id: key,
                        title: e.orderings[key]
                    })
                }
                this.orderings.reverse();
                this.orderingsId = this.orderings[0].id;

                // this.cancelReason = [];
                // for (key in e.cancel_reasons) {
                //     this.cancelReason.unshift({
                //         id: key,
                //         title: e.cancel_reasons[key]
                //     })
                // }
                // this.cancelReasonId = this.cancelReason[0].id;

                this.orderStatuses = [];
                for (key in e.order_statuses) {
                    this.orderStatuses.push({
                        id: key,
                        title: e.order_statuses[key]
                    })
                }
                this.orderStatuses.reverse();

                this.shipmentMethods = [];
                for (key in e.shipment_methods) {
                    this.shipmentMethods.push({
                        id: key,
                        title: e.shipment_methods[key]
                    })
                }
                this.shipmentMethods.reverse();
                this.shipmentMethodsId = this.shipmentMethods[0].id;

                this.employees = [];
                for (key in e.employees) {
                    this.employees.push({
                        id: key,
                        title: e.employees[key]
                    })
                }
                this.employees.reverse();
                this.employeesId = this.employees[0].id;

                this.employeesAll = [];
                for (key in e.employees_all) {
                    this.employeesAll.push({
                        id: key,
                        title: e.employees_all[key]
                    })
                }
                this.employeesAll.reverse();

                this.departments = [];
                for (key in e.departments) {
                    this.departments.push({
                        id: key,
                        title: e.departments[key]
                    })
                }
                this.departments.reverse();
                this.departmentsId = this.departments[0].id;

                this.paymentMethods = [];
                for (key in e.payment_methods) {
                    this.paymentMethods.push({
                        id: key,
                        title: e.payment_methods[key]
                    })
                }
                this.paymentMethods.reverse();
                this.paymentMethodsId = this.paymentMethods[0].id;

                this.utmSource = [];
                for (key in e.utm_sources) {
                    this.utmSource.push({
                        id: key,
                        title: e.utm_sources[key]
                    })
                }
                this.utmSource.reverse();
                this.utmSourceId = this.utmSource[0].id;

                this.utmMedium = [];
                for (key in e.utm_mediums) {
                    this.utmMedium.push({
                        id: key,
                        title: e.utm_mediums[key]
                    })
                }
                this.utmMedium.reverse();
                this.utmMediumId = this.utmMedium[0].id;

                this.utmTerms = [];
                for (key in e.utm_terms) {
                    this.utmTerms.push({
                        id: key,
                        title: e.utm_terms[key]
                    })
                }
                this.utmTerms.reverse();
                this.utmTermsId = this.utmTerms[0].id;

                this.utmContents = [];
                for (key in e.utm_contents) {
                    this.utmContents.push({
                        id: key,
                        title: e.utm_contents[key]
                    })
                }
                this.utmContents.reverse();
                this.utmContentsId = this.utmContents[0].id;

                this.utmCampaigns = [];
                for (key in e.utm_campaigns) {
                    this.utmCampaigns.push({
                        id: key,
                        title: e.utm_campaigns[key]
                    })
                }
                this.utmCampaigns.reverse();
                this.utmCampaignsId = this.utmCampaigns[0].id;
            }
        },
    },
    created() {
        // Статуси й довідники фільтрів незалежні — вантажимо їх паралельно.
        Promise.all([
            this.getOrderStatuses(),
            this.getPrepareFilters(),
        ]).then(() => {
            this.getReports()
        }).catch(() => {
            // Помилка відображається зі store (reportError).
        });
    },
    methods: {
        /**
         * Пошук підпису в довіднику фільтрів (display-only, без бізнес-логіки).
         */
        findTitle(dictionary, id) {
            if (!dictionary || id === null || id === undefined) {
                return null;
            }
            const found = dictionary.find(item => Number(item.id) === Number(id));
            return found ? found.title : null;
        },
        /**
         * Середній чек показується з серверних агрегатів (не зі сторінки).
         */
        mediumPrice(count, length) {
            const result = Number(count) / Number(length);
            return !isNaN(result) && isFinite(result) ? Number(result).toFixed(2) : '0.00';
        },
        getReports() {
            const payload = {
                created_from: this.date.from,
                created_to: this.date.to,
                product_category_id: this.productCategoriesId,
                product_id: this.productsId,
                order_by: this.orderingsId,
                order_statuses: this.orderStatusesToggle ? this.orderStatusesId : null,
                shipment_method_id: this.shipmentMethodsToggle ? this.shipmentMethodsId : null,
                employee_id: this.employeesToggle ? this.employeesId : null,
                department_id: this.departmentsToggle ? this.departmentsId : null,
                payment_method_id: this.paymentMethodsToggle ? this.paymentMethodsId : null,
                utm_source: this.utmSourceToggle ? this.utmSourceId : null,
                utm_medium: this.utmMediumToggle ? this.utmMediumId : null,
                utm_term: this.utmTermsToggle ? this.utmTermsId : null,
                utm_content: this.utmContentsToggle ? this.utmContentsId : null,
                utm_campaign: this.utmCampaignsToggle ? this.utmCampaignsId : null,
                cancel_reason: this.cancelReasonId ? this.cancelReasonId : null,
            }
            this.buildReport(payload).catch(() => {
                // Помилка відображається зі store (reportError).
            });
        },
        onPageChange(page) {
            this.changePage(page).catch(() => {
                // Помилка відображається зі store (reportError).
            });
        },
        onProductsPageChange(page) {
            this.changeProductsPage(page).catch(() => {
                // Помилка відображається зі store (reportError).
            });
        },
        onPerPageChange(value) {
            this.changePerPage(value).catch(() => {
                // Помилка відображається зі store (reportError).
            });
        },
        ...mapActions({
            getPrepareFilters: 'statistics/getPrepareFilters',
            buildReport: 'statistics/buildReport',
            changePage: 'statistics/changePage',
            changeProductsPage: 'statistics/changeProductsPage',
            changePerPage: 'statistics/changePerPage',
            getOrderStatuses: 'orders/getOrderStatuses'
        }),
    }
}
